"use client";

import { useRef } from "react";
import { FolderOpen } from "lucide-react";
import { IconButton } from "../ui/icon-button";
import {
  markdownFileAccept,
  readMarkdownFile,
  type ReadMarkdownFileSuccess,
} from "./read-markdown-file";

export function OpenMarkdownFileButton({
  compact = false,
  onLoaded,
  onError,
}: Readonly<{
  compact?: boolean;
  onLoaded: (result: ReadMarkdownFileSuccess) => void;
  onError?: (message: string) => void;
}>) {
  const inputRef = useRef<HTMLInputElement>(null);

  async function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files?.[0];
    // Allow selecting the same file again after a failed or successful open.
    event.target.value = "";

    if (!file) {
      return;
    }

    const result = await readMarkdownFile(file);
    if (!result.ok) {
      onError?.(result.error);
      return;
    }

    onLoaded(result);
  }

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={markdownFileAccept}
        className="sr-only"
        tabIndex={-1}
        aria-hidden="true"
        onChange={handleChange}
      />
      <IconButton
        label="Open Markdown file"
        compact={compact}
        onClick={() => inputRef.current?.click()}
      >
        <FolderOpen
          aria-hidden="true"
          className={compact ? "size-4" : "size-5"}
        />
      </IconButton>
    </>
  );
}
